(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-card').forEach(card => {
      if (!card.querySelector('swatches-variant-picker-component')) {
        card.querySelectorAll('a[href*="?variant="]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.delete('variant');
          link.href = url.toString();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
